import { useEffect, useState } from "react"
import { GetApp } from "../../App"
import { BlockRow, BlockField } from "../../Components/Block"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { InfoDialog } from "../../Components/InfoDialog"
import { IShipSettings } from "../../Types"

interface KeepRpmSettingViewProps {
  settings: IShipSettings;
  onEdited: () => void;
}

// Keep-manual-RPM section of the settings tab. Keeps its toggle in sync with the
// ship settings.
export function KeepRpmSettingView({ settings, onEdited }: KeepRpmSettingViewProps) {
  const app = GetApp()!;
  const t = app.getT("ShipSettingsView");
  const [keepManualRpm, setKeepManualRpm] = useState<boolean>(settings?.keepManualRpm ?? false);
  const [showRpmInfo, setShowRpmInfo] = useState(false);

  useEffect(() => {
    setKeepManualRpm(settings?.keepManualRpm ?? false);
  }, [settings?.keepManualRpm]);

  return (
    <>
      <hr></hr>
      <BlockRow>
        <h3 className="block-row-followed-by-block-row">{t("rpm_title")}</h3>
      </BlockRow>
      <BlockRow className="block-row-checkboxes block-row-one-row">
        <BlockField label={t("rpm_keep_manual")} labelAfter={true} labelFor="KeepManualRpm" className="checkbox-text-bigger">
          <input type="hidden" name="keepManualRpm" value={keepManualRpm ? "true" : "false"} />
          <input id="KeepManualRpm" type="checkbox" checked={keepManualRpm} onChange={() => { setKeepManualRpm(!keepManualRpm); onEdited(); }} />
        </BlockField>
        {/* Button for more info */}
        <BlockField>
          <button type="button" className="button" onClick={() => setShowRpmInfo(true)}>
            <span className="question-circle">?</span>  {t("more_info")}
          </button>
        </BlockField>

      </BlockRow>
      {showRpmInfo && (
        <InfoDialog
          title={t("rpm_title")}
          message={<LocalizedMessage message={(m) => m.shipSetting.keep_rpm} />}
          onClose={() => setShowRpmInfo(false)}
          style="info"
        />
      )}
    </>
  );
}
